<template>
  <div class="twig-layout-background" :class="{ 'light-theme': inverse }">
    <t-loading-spinner
      :large="large"
      :extra-large="extraLarge"
    ></t-loading-spinner>
  </div>
</template>

<script lang="ts" setup>
import TLoadingSpinner from "../TLoadingSpinner/TLoadingSpinner.vue";

defineProps({
  inverse: {
    type: Boolean,
    default: false,
  },

  large: {
    type: Boolean,
    default: false,
  },

  extraLarge: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.twig-layout-background {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
